/* PWT Mega Nav — hover image swap for description-left and
   category-preview panels. Links carry data-image/data-caption/
   data-price (computed in Liquid from each collection's first
   product); the panel holds [data-pwt-swap="image|caption|price"]. */
(function () {
  function init() {
    var links = document.querySelectorAll('.pwt-mega [data-pwt-swap-link]');
    if (!links.length) return;
    links.forEach(function (a) {
      a.addEventListener('mouseenter', function () {
        var panel = a.closest('.pwt-mega');
        if (!panel) return;
        var img = panel.querySelector('[data-pwt-swap="image"]');
        var cap = panel.querySelector('[data-pwt-swap="caption"]');
        var price = panel.querySelector('[data-pwt-swap="price"]');
        var src = a.getAttribute('data-image');
        if (img && src && img.getAttribute('src') !== src) {
          img.removeAttribute('srcset');
          img.setAttribute('src', src);
        }
        if (cap && a.getAttribute('data-caption')) {
          cap.textContent = a.getAttribute('data-caption');
        }
        if (price) {
          price.textContent = a.getAttribute('data-price') || '';
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* On templates where theme.css is print-deferred, theme.js can stamp
     #StickyHeaderWrap's height from a pre-theme.css measurement of the
     header. Once every stylesheet has loaded, poke headerNav's debounced
     resize recalc so the spacer matches the real header height. */
  function recalcStickyHeader() {
    window.dispatchEvent(new Event('resize'));
  }
  if (document.readyState === 'complete') {
    recalcStickyHeader();
  } else {
    window.addEventListener('load', recalcStickyHeader);
  }
})();


/* Drawer scrim + scroll lock: mirror #NavDrawer's open state onto <html> so
   the shared .pwt-nav-overlay dims the page; tapping the scrim closes. */
(function () {
  var drawer = document.getElementById('NavDrawer');
  if (!drawer) return;
  var overlayEl = document.querySelector('.pwt-nav-overlay');
  var sync = function () {
    var open = drawer.classList.contains('drawer--is-open');
    document.documentElement.classList.toggle('pwt-drawer-open', open);
    if (overlayEl) {
      overlayEl.style.opacity = open ? '1' : '';
      overlayEl.style.pointerEvents = open ? 'auto' : '';
      overlayEl.style.zIndex = open ? '24' : '';
    }
  };
  new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  sync();
  if (overlayEl) {
    overlayEl.addEventListener('click', function () {
      if (!drawer.classList.contains('drawer--is-open')) return;
      var close = drawer.querySelector('.js-drawer-close');
      if (close) close.click();
    });
  }
})();
